export class CustomFieldChoice {
    id: number;
    title: string;
    order = 0;
    is_active = true;
}
